import { Button, Col, Row, Input, DatePicker, Popover } from "antd";
import { useNavigate } from "react-router";
import { useSearchParams } from "react-router-dom";
import dayjs from "dayjs";
import TableColumn from "./columns";
import {
  FileExcelOutlined,
  FilePdfOutlined,
  PrinterOutlined,
} from "@ant-design/icons";
import UserManualButton from "../../../components/UserManualButton";
import SelectPallet from "../../../components/SelectPallet";
import SelectClientProduct from "../../../components/SelectClientProduct";
const { Search } = Input;

const FilterMenu = (props) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();

  const onSearch = (value) => {
    if (props.selectedFilter === "Client") {
      updateSearchParams({ specification: value || null, page: 1 });
    } else {
      updateSearchParams({ client_name: value || null, page: 1 });
    }
  };

  const onClear = (value) => {
    updateSearchParams({ specification: null, page: 1 });
  };

  const handleNavigate = () => {
    navigate(`/inbound/add`);
  };

  const updateSearchParams = (params = {}) => {
    const newSearchParams = new URLSearchParams(searchParams);

    Object.entries(params).forEach(([key, value]) => {
      if (value !== null && value !== undefined) {
        newSearchParams.set(key, value);
      } else {
        newSearchParams.delete(key);
      }
    });

    setSearchParams(newSearchParams);
  };

  return (
    <Row
      align="top"
      style={{ marginBottom: "18px" }}
      justify={"space-between"}
      gutter={[8, 8]}
    >
      <Col lg={16} xs={24}>
        <Row gutter={[8, 8]} align={"middle"}>
          <Col lg={6} md={6} sm={12} xs={24}>
            <DatePicker
              style={{ width: "100%" }}
              format="YYYY-MM-DD"
              placeholder="Pilih Tanggal"
              onChange={(e) =>
                updateSearchParams({
                  received_at: e ? dayjs(e).format("YYYY-MM-DD") : null,
                  page: 1,
                })
              }
            />
          </Col>
          <Col lg={6} md={6} sm={12} xs={24}>
            {props.isClientUser ? (
              <SelectClientProduct
                nullOptions={!searchParams.get("client_id")}
                idClient={searchParams.get("client_id") || null}
                value={+searchParams.get("product_id")}
                onChange={(e) => {
                  updateSearchParams({
                    product_id: e,
                  });
                }}
              />
            ) : (
              <SelectPallet
                value={+searchParams.get("pallet_id")}
                onChange={(e) => {
                  updateSearchParams({
                    pallet_id: e,
                  });
                }}
                usedOnly
              />
            )}
          </Col>
          <Col lg={3} md={4} sm={5} xs={24}>
            <div style={{ display: "flex", gap: "0.5rem" }}>
              <Button
                style={{ width: "100%" }}
                onClick={() => {
                  setSearchParams({});
                }}
              >
                Clear Filter
              </Button>
              <UserManualButton />
            </div>
          </Col>
        </Row>
      </Col>
      <Col lg={8} xs={24}>
        <Row gutter={[8, 8]} align={"middle"} justify={"end"}>
          <Col xl={12} lg={14} md={6} sm={8} xs={24}>
            <Search
              placeholder={
                props.selectedFilter === "Client"
                  ? "Cari Spesifikasi"
                  : "Cari Nama Client"
              }
              allowClear
              defaultValue={
                props.selectedFilter === "Client"
                  ? searchParams.get("specification") || null
                  : searchParams.get("client_name") || null
              }
              onSearch={onSearch}
              style={{ width: "100%" }}
              onClear={onClear}
            />
          </Col>
          {props.data?.length > 0 && (
            <Popover
              content={
                <Row gutter={8}>
                  <Col span={12}>
                    <Button
                      type="primary"
                      style={{ backgroundColor: "#1D6F42" }}
                      icon={<FileExcelOutlined />}
                      onClick={() => props.exportToExcel(TableColumn())}
                    >
                      Excel
                    </Button>
                  </Col>
                  <Col span={12}>
                    <Button
                      type="primary"
                      style={{ backgroundColor: "#F40F02" }}
                      icon={<FilePdfOutlined />}
                      onClick={() => props.exportToPDF(TableColumn())}
                    >
                      PDF
                    </Button>
                  </Col>
                </Row>
              }
            >
              <Button
                type="primary"
                style={{ backgroundColor: "#4caf50" }}
                icon={<PrinterOutlined />}
              >
                Print
              </Button>
            </Popover>
          )}
        </Row>
      </Col>
    </Row>
  );
};

export default FilterMenu;
